import '../../../App.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import MediaMtxHlsVideo from '../../../components/MediaMtxHlsVideo';
import { buttonStyle, CollapsableDiv } from '../shared/SharedComponents';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../features/auth/authSlice';
import { useState } from 'react';

export const RealTimeCameraDiv = ({ schedule }: any) => {
    // console.log('render real time cam')
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { width, fontWeight, ...localButtonStyle } = buttonStyle

    const handleLightOn = async () => {
        try {
            const response = await fetch('https://uat.castco.com.hk/api/WebSocket/allLightOn');
            const data = await response.json();
            // console.log(data);


        } catch (error) {
            console.error('Error:', error);
        } finally {
        }
    };

    const handleLightOff = async () => {
        try {
            const response = await fetch('https://uat.castco.com.hk/api/WebSocket/allLightOff');
            const data = await response.json();
            // console.log(data);


        } catch (error) {
            console.error('Error:', error);
        } finally {
        }
    };

    const user = useSelector(selectCurrentUser)
    const [videoSetting, setVideoSetting] = useState(
        {
            IsShowLabel: false,
            Url:`${process.env.REACT_APP_MEDIAMTX_PROTOCOL}://${user}@${process.env.REACT_APP_MEDIAMTX_HOST}/hls/${schedule.id}/index.m3u8?controls=false`
        }
    )

    const toggleShowLabel = () => {
        if (videoSetting.IsShowLabel)
            setVideoSetting(
                {
                    IsShowLabel: false,
                    Url:`${process.env.REACT_APP_MEDIAMTX_PROTOCOL}://${user}@${process.env.REACT_APP_MEDIAMTX_HOST}/hls/${schedule.id}/index.m3u8?controls=false`
                }
            )
        else
            setVideoSetting(
                {
                    IsShowLabel: true,
                    Url:`${process.env.REACT_APP_MEDIAMTX_PROTOCOL}://${user}@${process.env.REACT_APP_MEDIAMTX_HOST}/hls/${schedule.id}_view/index.m3u8?controls=false`
                }
            )
    } 

    return (

        <CollapsableDiv
            title={t("Real Time Camera")}>
            {/* <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontSize: "16px", }}>{t("Real Time Camera")} 1</div>
                {/* <img style={{ maxWidth: '100%', width: '480px', }} src={camera1Demo} /> */}
            {/* <iframe src="http://localhost:8889/test/" height="800" /> */}
            {/* <MediaMtxWebRtcVideo mediaMtxWebRtcUrl="https://uat.castco.com.hk/web-rtc/mystream_view/" style={{ maxWidth: '100%', width: '480px', }} /> */}
            <div>
                <MediaMtxHlsVideo 
                    mediaMtxHlsUrl={videoSetting.Url} 
                    additionalButtons={
                        <button style=
                            {
                                {
                                    ...localButtonStyle,
                                    fontFamily: 'Faune', width: 'fit-content', fontSize: '18px',
                                    fontWeight: '400', marginTop: '10px', paddingLeft: '15px', paddingRight: '15px',
                                    marginLeft: "10px"
                                }
                            }
                            onClick={toggleShowLabel}
                        >
                            {videoSetting.IsShowLabel ? "Hide Label" : "Show Label"}
                        </button>
                    }
                    style={{ maxWidth: '100%', width: '480px', }} />
            </div>
            {/* <button style=
                {
                    {
                        ...localButtonStyle,
                        fontFamily: 'Faune', width: 'fit-content', fontSize: '18px',
                        fontWeight: '400', marginTop: '10px', paddingLeft: '15px', paddingRight: '15px'
                    }
                }
                onClick={() => navigate("/safety-monitoring", { state: schedule })}>
                {t("Safely Monitoring")}
            </button> */}
            <div>
                <label style={{ marginRight: "10px" }}>Alert Light:</label>
                <button
                    style=
                    {
                        {
                            ...localButtonStyle,
                            fontFamily: 'Faune', width: 'fit-content', fontSize: '18px',
                            fontWeight: '400', marginTop: '10px', paddingLeft: '15px', paddingRight: '15px'

                        }
                    }
                    onClick={handleLightOn}
                >
                    On
                </button>
                <button style=
                    {
                        {
                            ...localButtonStyle,
                            fontFamily: 'Faune', width: 'fit-content', fontSize: '18px',
                            fontWeight: '400', marginTop: '10px', paddingLeft: '15px', paddingRight: '15px',
                            marginLeft: "10px"
                        }
                    }
                    onClick={handleLightOff}
                >
                    Off
                </button>
            </div>

        </CollapsableDiv>
    )
}